import authActions from './auth/actions'
import distributorActions from './distributor/actions'

export default store =>
	new Promise(() => {
		store.dispatch(authActions.checkAuthorization())
		store.dispatch(distributorActions.getFullList())
	})